import React, { useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import sv from "date-fns/locale/sv";
registerLocale("sv", sv);

const CustomDatePicker = ({
  selectedDate = null,
  firstDate = null,
  lastDate = null,
  avDates = null,
  customInput,
  onChange,
  popperPlacement = "auto",
  showPopperArrow = true,
}) => {
  const [date, setDate] = useState(firstDate);

  const updateDate = (newDate) => {
    setDate(newDate);
    onChange(newDate);
  };

  useEffect(() => {
    if (lastDate !== null) setDate(lastDate);

    if (selectedDate !== null) {
      setDate(selectedDate);
    }
  }, [lastDate, selectedDate]);

  return (
    <div
      className='d-flex justify-content-between align-items-center'
    >
      <span>
        <DatePicker
          selected={date}
          onChange={(newDate) => updateDate(newDate)}
          dateFormat="yyyy-MM-dd"
          customInput={customInput}
          showDayMonthPicker
          showMonthDropdown={true}
          showYearDropdown={true}
          popperPlacement={popperPlacement}
          minDate={firstDate}
          includeDates={avDates}
          maxDate={lastDate !== null ? moment(lastDate).toDate() : null}
          locale="sv"
          showPopperArrow={showPopperArrow}
        />
      </span>
    </div>
  );
};

export default CustomDatePicker;
